import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import storage from './utils/Storage'
import tools from './utils/tools'
import oss from './utils/oss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../src/assets/iconfont/iconfont.css'
import '../src/assets/css/pc_common.css'
import request from './utils/request'
import './assets/css/fonts.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// 引入样式
import 'swiper/css/swiper.css'


 
import 'xe-utils' 
import VxeUIAll from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'


import ServiceAgreement from './components/ServiceAgreement.vue'//用户服务协议
import UploadImgList from "@/components/UploadImgList.vue";//上传
import DownLoadList from "@/components/DownLoadList.vue";//上传列表
import LoadingCell from "@/components/LoadingCell.vue";//loading状态
import WalletPassword from '@/components/WalletPassword.vue'//资产密码输入
 import PreviewImage from "@/components/PreviewImage.vue"; //预览图片

// 聊天
import TencentCloudChat from '@/utils/tencentChat.js';
import ChatService from '@/utils/chatSdk.js';
Vue.prototype.$tencentChat = TencentCloudChat;
Vue.prototype.$ChatService = ChatService;
 

import filters from './utils/filters'

// 格式化日期
import dayjs from "dayjs"
Vue.prototype.$dayjs = dayjs;

// 注册组件
Vue.component('ServiceAgreement',ServiceAgreement)
Vue.component('UploadImgList',UploadImgList)
Vue.component('DownLoadList',DownLoadList)
Vue.component('LoadingCell',LoadingCell)
Vue.component('WalletPassword',WalletPassword)
Vue.component('PreviewImage',PreviewImage)

// 事件总站
import EventBus from './utils/event-bus'
Vue.prototype.$EventBus = EventBus;

//注册过滤器
for( let key in filters) {
  Vue.filter(key,filters[key])
}

// 公共方法
Vue.prototype.$storage=storage
Vue.prototype.$request=request
Vue.prototype.$tools=tools
Vue.prototype.$oss=oss
Vue.use(ElementUI)

Vue.use(VxeUIAll)
Vue.use(VXETable)
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

new Vue({
  router,store,
  render: h => h(App),
}).$mount('#app')
